import {
  CLASES_RECIBIDAS,
  CLASS_TYPES_RECIBIDOS,
  CREATE_CLASE,
  HIDE_SPINNER,
  RESERVATIONS_RECIBIDAS,
  SEMANAS_RECIBIDAS,
  SET_CLASE,
  SET_PROPIEDAD_CLASE,
  SHOW_SPINNER,
  TOTAL_RECIBIDO,
  SET_MONTH,
  SET_WEEK,
  SET_START_DATE,
  SET_END_DATE,
  SET_CAN_ADVANCE,
  SET_USER_CLICK,
} from "../types";

const schema = {
  class_instructor_id: "nueva",
  description: "",
  instructor_id: "",
  location_id: "",
  class_type_id: "",
  capacity: "",
  class_date: "",
  is_virtual_class: false,
  is_special_event: false,
};

const ClassInstructorReducer = (state, { type, payload }) => {
  switch (type) {
    case SEMANAS_RECIBIDAS:
      return { ...state, days: payload };
    case RESERVATIONS_RECIBIDAS:
      return { ...state, reservations: payload };
    case SET_CLASE:
      return { ...state, clase: payload };
    case SET_PROPIEDAD_CLASE:
      const clase = { ...state.clase };
      const { key, value } = payload;
      clase[key] = value;
      return { ...state, clase };
    case CREATE_CLASE:
      return { ...state, clase: schema };
    case CLASS_TYPES_RECIBIDOS:
      return { ...state, class_types: payload };
    case CLASES_RECIBIDAS:
      return { ...state, clases: payload };
    case TOTAL_RECIBIDO:
      return { ...state, total: payload };
    case SHOW_SPINNER:
      return { ...state, spinner: true };
    case HIDE_SPINNER:
      return { ...state, spinner: false };
    case SET_MONTH:
      return { ...state, month: payload };
    case SET_WEEK:
      return { ...state, selectedWeek: payload };
    case SET_START_DATE:
      return { ...state, start_date: payload };
    case SET_END_DATE:
      return { ...state, end_date: payload };
    case SET_CAN_ADVANCE:
      return { ...state, canAdvance: payload };
    case SET_USER_CLICK:
      return { ...state, clicked: payload };
    default:
      return { ...state };
  }
};

export default ClassInstructorReducer;
